// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__io9+v","Checkbox__input":"Checkbox_Checkbox__input__8qg99","Checkbox__checkbox":"Checkbox_Checkbox__checkbox__8f3hg"};